export type CaseStatus = 'active' | 'pending_review' | 'closed' | 'archived' | 'referred';
export type RiskLevel = 'low' | 'moderate' | 'high' | 'critical';

export interface CaseRecord {
  id: string;
  caseNumber: string;
  childId: string;
  childName: string;
  age: number;
  gender: string;
  status: CaseStatus;
  riskLevel: RiskLevel;
  assignedWorker: string;
  assignedWorkerId: string;
  createdAt: string;
  updatedAt: string;
  incidentType: string;
  barangay: string;
  municipality: string;
  province: string;
  supervisorApproval: 'pending' | 'approved' | 'rejected' | 'not_required';
  referralAgency?: string;
}

export const mockCases: CaseRecord[] = [
  {
    id: 'c1',
    caseNumber: 'DCPCMS-2026-00001',
    childId: 'ch1',
    childName: 'Juan Dela Cruz',
    age: 8,
    gender: 'Male',
    status: 'active',
    riskLevel: 'critical',
    assignedWorker: 'Maria Santos',
    assignedWorkerId: 'u1',
    createdAt: '2026-01-15',
    updatedAt: '2026-04-08',
    incidentType: 'Physical Abuse',
    barangay: 'Brgy. San Jose',
    municipality: 'Batangas City',
    province: 'Batangas',
    supervisorApproval: 'approved',
  },
  {
    id: 'c2',
    caseNumber: 'DCPCMS-2026-00002',
    childId: 'ch2',
    childName: 'Ana Reyes',
    age: 12,
    gender: 'Female',
    status: 'pending_review',
    riskLevel: 'high',
    assignedWorker: 'Maria Santos',
    assignedWorkerId: 'u1',
    createdAt: '2026-02-03',
    updatedAt: '2026-04-07',
    incidentType: 'Neglect',
    barangay: 'Brgy. Poblacion',
    municipality: 'Lipa City',
    province: 'Batangas',
    supervisorApproval: 'pending',
  },
  {
    id: 'c3',
    caseNumber: 'DCPCMS-2026-00003',
    childId: 'ch3',
    childName: 'Pedro Villanueva',
    age: 6,
    gender: 'Male',
    status: 'active',
    riskLevel: 'moderate',
    assignedWorker: 'Maria Santos',
    assignedWorkerId: 'u1',
    createdAt: '2026-02-20',
    updatedAt: '2026-04-05',
    incidentType: 'Child Labor',
    barangay: 'Brgy. Kumintang Ibaba',
    municipality: 'Batangas City',
    province: 'Batangas',
    supervisorApproval: 'approved',
  },
  {
    id: 'c4',
    caseNumber: 'DCPCMS-2026-00004',
    childId: 'ch4',
    childName: 'Sofia Mendoza',
    age: 15,
    gender: 'Female',
    status: 'referred',
    riskLevel: 'high',
    assignedWorker: 'Maria Santos',
    assignedWorkerId: 'u1',
    createdAt: '2026-03-01',
    updatedAt: '2026-04-06',
    incidentType: 'Sexual Abuse',
    barangay: 'Brgy. Alangilan',
    municipality: 'Batangas City',
    province: 'Batangas',
    supervisorApproval: 'approved',
    referralAgency: 'PNP Women & Children Protection Desk',
  },
  {
    id: 'c5',
    caseNumber: 'DCPCMS-2026-00005',
    childId: 'ch5',
    childName: 'Carlo Bautista',
    age: 10,
    gender: 'Male',
    status: 'closed',
    riskLevel: 'low',
    assignedWorker: 'Maria Santos',
    assignedWorkerId: 'u1',
    createdAt: '2025-11-10',
    updatedAt: '2026-03-15',
    incidentType: 'Emotional Abuse',
    barangay: 'Brgy. Sta. Rita Karsada',
    municipality: 'Batangas City',
    province: 'Batangas',
    supervisorApproval: 'approved',
  },
  {
    id: 'c6',
    caseNumber: 'DCPCMS-2026-00006',
    childId: 'ch6',
    childName: 'Liza Fernandez',
    age: 7,
    gender: 'Female',
    status: 'active',
    riskLevel: 'critical',
    assignedWorker: 'Maria Santos',
    assignedWorkerId: 'u1',
    createdAt: '2026-03-28',
    updatedAt: '2026-04-09',
    incidentType: 'Physical Abuse',
    barangay: 'Brgy. Cuta',
    municipality: 'Batangas City',
    province: 'Batangas',
    supervisorApproval: 'pending',
  },
  {
    id: 'c7',
    caseNumber: 'DCPCMS-2026-00007',
    childId: 'ch7',
    childName: 'Miguel Torres',
    age: 14,
    gender: 'Male',
    status: 'active',
    riskLevel: 'moderate',
    assignedWorker: 'Maria Santos',
    assignedWorkerId: 'u1',
    createdAt: '2026-04-01',
    updatedAt: '2026-04-08',
    incidentType: 'Neglect',
    barangay: 'Brgy. Pallocan West',
    municipality: 'Batangas City',
    province: 'Batangas',
    supervisorApproval: 'not_required',
  },
];

export const activityLog = [
  { id: 'a1', caseNumber: 'DCPCMS-2026-00001', action: 'Risk assessment updated', user: 'Maria Santos', timestamp: '2026-04-09 09:15', type: 'assessment' },
  { id: 'a2', caseNumber: 'DCPCMS-2026-00006', action: 'New case created', user: 'Maria Santos', timestamp: '2026-04-09 08:30', type: 'create' },
  { id: 'a3', caseNumber: 'DCPCMS-2026-00002', action: 'Submitted for supervisor review', user: 'Maria Santos', timestamp: '2026-04-08 16:45', type: 'review' },
  { id: 'a4', caseNumber: 'DCPCMS-2026-00004', action: 'Referred to PNP WCPD', user: 'Maria Santos', timestamp: '2026-04-08 14:20', type: 'referral' },
  { id: 'a5', caseNumber: 'DCPCMS-2026-00003', action: 'Document uploaded: Medical Certificate', user: 'Maria Santos', timestamp: '2026-04-07 11:00', type: 'document' },
  { id: 'a6', caseNumber: 'DCPCMS-2026-00001', action: 'Supervisor approved case', user: 'Jose Reyes', timestamp: '2026-04-07 09:30', type: 'approval' },
  { id: 'a7', caseNumber: 'DCPCMS-2026-00005', action: 'Case closed and archived', user: 'Maria Santos', timestamp: '2026-03-15 15:00', type: 'close' },
];
